export function demandReducer(state = "" ,{
    type,
    payload
}){
    
    switch(type){
        case "NEW_DEMAND":            
        case "UPDATE_DEMAND":
            let list = Object.assign({}, state);
            list[payload.demand_id] = payload
        
            return list
        
        case "GET_DEMANDS":
        case "GET_USER_DEMANDS":
        case "NEW_USER_DEMAND":

            return payload
            
        default:
            return state;
    }
    
}